import * as React from 'react';
import {PDFDocumentProxy, PDFRenderTask} from "pdfjs-dist";
import {EsignField} from "../../types";
import {useEffect, useRef} from "react";


type ExportPdfPageProps = {
    document: PDFDocumentProxy,
    page: number,
    fields: EsignField[],
}

const ExportPdfPage: React.FunctionComponent<ExportPdfPageProps> = (p) => {

    const canvasRef = useRef<HTMLCanvasElement>(null);
    const renderTask = useRef<PDFRenderTask | null>(null);


    useEffect(() => {
        if (!canvasRef.current) {
            return;
        }
        p.document.getPage(p.page).then((page) => {
            const rotate = 0;
            const scale = 1.5;
            const rotation = rotate === 0 ? page.rotate : page.rotate + rotate;
            const dpRatio = window.devicePixelRatio;
            const adjustedScale = scale * dpRatio;
            const viewport = page.getViewport({scale: adjustedScale, rotation});
            const canvasEl = canvasRef.current;
            if (!canvasEl) {
                return;
            }

            const canvasContext = canvasEl.getContext('2d');
            if (!canvasContext) {
                return;
            }

            canvasEl.style.width = `${viewport.width / dpRatio}px`;
            canvasEl.style.height = `${viewport.height / dpRatio}px`;
            canvasEl.height = viewport.height;
            canvasEl.width = viewport.width;

            if (renderTask.current) {
                renderTask.current.cancel();
                return;
            }

            renderTask.current = page.render({
                canvasContext,
                viewport,
            });

            renderTask.current.promise.then(() => {
            }).catch((e) => {
                console.log(e)
            })

        });

    }, [p.document, p.page]);

    return (<>
        <div className={"document-wrapper"}
             style={{position: "relative"}}>
            {
                p.fields.map((f) => (
                    <div key={"f_" + f.uuid}
                         style={{
                             fontSize: 12,
                             position: "absolute",
                             top: f.y,
                             left: f.x,
                             height: f.height,
                             width: f.width
                         }}>
                        {
                            (f.type === "signature" || f.type === "initial")
                                ? <img src={f.value} alt={"sig"} height={f.height} width={f.width}/>
                                : (f.type === "checkbox") ?
                                    (f.value === "checked") ? "X" : ""
                                    : f.value
                        }
                    </div>
                ))
            }
            <canvas ref={canvasRef}
                    style={{padding: 0, margin: 0, touchAction: "none"}}
            ></canvas>
        </div>
        <div className="pagebreak"></div>
    </>);
};

export default ExportPdfPage;